@if (showButtons) {
<div class="action-button-container" data-action-buttons style="display: flex;
    justify-content: flex-end;">
    @if (showReEnable) {
      <button class="btn-medium-secondary" style="padding: 0 20px !important;"
        data-reenable-button
        (click)="checkPfDeleted('REACTIVATE')"
      [disabled]="isDisabled || isAutomated">Re-enable this result</button>
    }
    @if (showOnBlotter) {
<button class="btn-medium-primary" style="padding: 0 20px !important;margin-left: auto!important;
    margin-right: auto!important;"
        data-blotter-button
        (click)="viewOrdersOnBlotter()"
      [disabled]="isDisabled">View orders on blotter</button>
    }
    @if (showRecall) {
      <button class="btn-medium-secondary" style="padding: 0 20px !important;"
        data-recall-button
        (click)="checkPfDeleted('RECALL')"
      [disabled]="isDisabled || isAutomated">Recall orders from blotter</button>
    }
    @if (showApproveOrRefuse) {
      <button  class="btn-medium-primary" style="width: 100px;"
        data-approve-button
        (click)="checkWarningsAndApprove()"
        tooltip tooltipPosition="bottom" tooltipTitle="Send orders to blotter"
      [disabled]="!isTrader || isDisabled || isAutomated">Approve</button>
      <button class="btn-medium-secondary btnWithArrow" style="position: relative; width: 100px; padding-left: 20px !important;"
        data-refuse-button
        [disabled]="isDisabled || isAutomated"
        [matMenuTriggerFor]="subMenu1"
        >Refuse<i
      class="material-icons md-24 md-align dropdown-arrow-align">arrow_drop_down</i>
      <mat-menu #subMenu1="matMenu" class="nav__items_action_btn" yPosition="below" data-refuse-menu>
        <button class="nav__item_action_btn" mat-menu-item data-refuse (click)="refuse()"><span
        class="bold">Refuse</span> | Do not send orders
      </button>
      <button class="nav__item_action_btn" mat-menu-item data-resubmit (click)="refuseAndResubmit()"><span
      class="bold">Refuse</span> | Resubmit portfolio
    </button>
  </mat-menu>
</button>
}
</div>
}
<ng-template #workflowDialogTemplate>
  <div mat-dialog-title style="margin-bottom: 20px !important;">{{workflowDialogData?.title}}</div>
  <!--div *ngIf="workflowDialogData?.warning" class="statusMessage warning" style="max-width: 760px;width:760px;background-size: 15px 15px;height:25px">
  <p style="marginTop:10px;display:inline-block;background-size: 15px 15px;">
    <span class="main">
      {{workflowDialogData?.warning}}
    </span>
  </p>
</div-->
<div style="padding: 0 15px;">
  @if (workflowDialogData?.warning) {
    <div class="irb-dialog" style="max-width: 760px;width:760px;">
      <mat-card class="block warn" style="margin-bottom: 20px !important;">
        <mat-card-title style="white-space: pre-line;" [innerHTML]="workflowDialogData?.warning"></mat-card-title>
      </mat-card>
    </div>
  }
  @if (workflowDialogData?.gridCounter) {
    <div style="margin-bottom:10px;" >
      <span class="main">
        {{workflowDialogData?.gridCounter}}
      </span>
    </div>
  }
  @if (workflowDialogData?.content) {
    <p>{{workflowDialogData?.content}}</p>
  }

  @if (workflowDialogData && workflowDialogData.isGridRequired) {
    <irb-inventory-grid
      [style.minHeight]="'300px'"
      [gridHeight]="'300px'"
      [showSideBar]="false"
      [gridOptions]="workflowDialogData.gridOptions"
      [columnDefs]="workflowDialogData.gridOptions.columnDefs"
    [rowData]="workflowDialogData.rowData"></irb-inventory-grid>
  }
</div>
@if (workflowDialogData && !workflowDialogData.isRebalanceSubmittedBtns) {
  <mat-dialog-actions>
    <button id="closeButtonWarningDailog" mat-dialog-close class="btn-medium-secondary">Close</button>
    <button id="proceedButton" (click)="workflowProceed()" class="btn-medium-primary">Proceed</button>
  </mat-dialog-actions>
}
@if (workflowDialogData && workflowDialogData.isRebalanceSubmittedBtns) {
  <mat-dialog-actions>
    <button id="closeButtonWarningDailog" (click)="workflowDialogData.closeAction()" mat-dialog-close class="btn-medium-secondary">Cancel - stay on this page</button>
    <button id="proceedButton" (click)="workflowDialogData.nextAction()" class="btn-medium-primary">Continue - go to new result</button>
  </mat-dialog-actions>
}
</ng-template>

